<template>
  <div class="legal-wrap" :class="isZh ? 'lang-cn' : 'lang-it'">
    <Head></Head>
    <div class="page">
      <div class="doc-header">
        <!-- Cookie 政策 -->
        <h1 class="doc-title doc-title-single">
          {{ $fanyi("Cookie 政策") }}
        </h1>
        <div class="doc-sub">
          ADVANCING DIGITAL TRADE CO., LIMITED · www.rakumart.it
        </div>
      </div>

      <section class="sec">
        <h2 class="sec-title">
          <span class="it">Che cosa sono i cookie?</span>
          <span class="cn">什么是 Cookie？</span>
        </h2>
        <div class="bi">
          <p class="it">
            I cookie sono piccoli file di dati che vengono ricevuti sul
            dispositivo dell'utente da un sito web visitato e vengono utilizzati
            per registrare determinate interazioni di navigazione sul sito,
            memorizzando dati che potranno essere aggiornati e recuperati.
          </p>
          <p class="cn">
            Cookie
            是访问网站时被接收到用户设备上的小型数据文件，用于记录网站上的某些浏览交互，存储可被更新和检索的数据。
          </p>
        </div>
        <div class="bi">
          <p class="it">
            Tali file vengono salvati sul computer dell'utente e contengono dati
            anonimi che non sono dannosi per il dispositivo. Sono utilizzati per
            ricordare le preferenze dell'utente, come la lingua selezionata, i
            dati di accesso o le impostazioni di personalizzazione.
          </p>
          <p class="cn">
            这些文件保存在用户的计算机上，包含对设备无害的匿名数据。它们用于记住用户的偏好，如所选语言、登录数据或个性化设置。
          </p>
        </div>
        <div class="bi">
          <p class="it">
            I cookie possono inoltre essere utilizzati per registrare
            informazioni anonime sul modo in cui il visitatore utilizza il sito
            web, ad esempio da quale pagina web è arrivato o se ha utilizzato un
            banner pubblicitario per accedere al sito.
          </p>
          <p class="cn">
            Cookie
            还可用于记录访客如何使用网站的匿名信息，例如访客从哪个网页进入，或是否通过广告横幅访问本站。
          </p>
        </div>
      </section>

      <section class="sec">
        <h2 class="sec-title">
          <span class="it"
            >Quali sono gli utilizzi dei diversi tipi di cookie?</span
          >
          <span class="cn">不同类型 Cookie 的用途是什么？</span>
        </h2>

        <div class="group-label">
          <span class="it">In base alla finalità</span>
          <span class="cn">按用途分类</span>
        </div>
        <div class="type-card">
          <div class="type-name">
            <span class="it">Cookie tecnici</span>
            <span class="cn">技术性 Cookie</span>
          </div>
          <p class="it">
            I cookie tecnici sono quelli indispensabili e strettamente necessari
            per il corretto funzionamento di un sito web e per l'utilizzo delle
            diverse opzioni e servizi offerti. Ad esempio, quelli necessari per
            il mantenimento della sessione, la gestione dei tempi di risposta,
            il rendimento o la convalida delle opzioni, l'utilizzo di elementi
            di sicurezza, la condivisione di contenuti sui social network, ecc.
          </p>
          <p class="cn">
            技术性 Cookie
            是网站正常运行以及使用其提供的各种选项和服务所必不可少且严格必要的
            Cookie。例如，用于维持会话、管理响应时间、性能或选项验证、使用安全元素、与社交网络共享内容等的
            Cookie。
          </p>
        </div>
        <div class="type-card">
          <div class="type-name">
            <span class="it">Cookie di personalizzazione</span>
            <span class="cn">个性化 Cookie</span>
          </div>
          <p class="it">
            Questi cookie consentono all'utente di specificare o personalizzare
            alcune caratteristiche delle opzioni generali del sito web, ad
            esempio la lingua, la configurazione regionale o il tipo di browser.
          </p>
          <p class="cn">
            此类 Cookie
            允许用户指定或个性化网站通用选项的某些特性，例如语言、区域设置或浏览器类型。
          </p>
        </div>
        <div class="type-card">
          <div class="type-name">
            <span class="it">Cookie analitici</span>
            <span class="cn">分析性 Cookie</span>
          </div>
          <p class="it">
            I cookie analitici sono utilizzati dal nostro sito web per elaborare
            profili di navigazione e conoscere le preferenze degli utenti, con
            lo scopo di migliorare l'offerta di prodotti e servizi. Ad esempio,
            tramite un cookie analitico è possibile monitorare le aree
            geografiche di maggiore interesse per un utente, il prodotto più
            apprezzato, ecc.
          </p>
          <p class="cn">
            分析性 Cookie
            由我们的网站用于建立浏览画像并了解用户偏好，以改进产品和服务的供应。例如，通过分析性
            Cookie 可以监测用户最感兴趣的地理区域、最受欢迎的产品等。
          </p>
        </div>
        <div class="type-card">
          <div class="type-name">
            <span class="it">Cookie pubblicitari / di pubblicità</span>
            <span class="cn">广告 Cookie</span>
          </div>
          <p class="it">
            I cookie pubblicitari consentono la gestione degli spazi
            pubblicitari secondo criteri specifici, come la frequenza di accesso
            o il contenuto visualizzato. Attraverso la gestione della
            pubblicità, tali cookie permettono di memorizzare informazioni sul
            comportamento dell'utente, osservandone le abitudini, studiando gli
            accessi e creando un profilo di preferenze per offrire pubblicità in
            linea con i suoi interessi.
          </p>
          <p class="cn">
            广告 Cookie
            可根据特定标准（如访问频率或显示的内容）管理广告空间。通过广告管理，此类
            Cookie
            能够存储用户行为信息，观察其习惯、研究访问情况并建立偏好画像，从而提供符合其兴趣的广告。
          </p>
        </div>

        <div class="group-label">
          <span class="it">In base alla durata</span>
          <span class="cn">按时长分类</span>
        </div>
        <div class="type-card">
          <div class="type-name">
            <span class="it">Cookie di sessione</span>
            <span class="cn">会话 Cookie</span>
          </div>
          <p class="it">
            I cookie di sessione sono quelli che rimangono attivi durante il
            periodo in cui l'utente naviga sul sito web e vengono eliminati al
            termine della navigazione.
          </p>
          <p class="cn">
            会话 Cookie 在用户浏览网站期间保持有效，并在浏览结束时被删除。
          </p>
        </div>
        <div class="type-card">
          <div class="type-name">
            <span class="it">Cookie persistenti</span>
            <span class="cn">持久性 Cookie</span>
          </div>
          <p class="it">
            Questi cookie restano memorizzati sul dispositivo dell'utente per un
            periodo più lungo, facilitando il controllo delle preferenze
            selezionate senza dover ripetere determinate impostazioni a ogni
            visita del sito web.
          </p>
          <p class="cn">
            此类 Cookie
            在用户设备上保存较长时间，便于控制所选偏好，无需在每次访问网站时重复某些设置。
          </p>
        </div>
      </section>

      <section class="sec">
        <h2 class="sec-title">
          <span class="it">Perché utilizziamo i cookie?</span>
          <span class="cn">我们为什么使用 Cookie？</span>
        </h2>
        <div class="bi">
          <p class="it">
            Utilizziamo cookie strettamente necessari ed essenziali affinché
            l'utente possa utilizzare il nostro sito web, navigare liberamente,
            accedere ad aree sicure, configurare opzioni personalizzate, ecc.
            Utilizziamo inoltre cookie che raccolgono dati relativi all'analisi
            dell'utilizzo del sito. Questi cookie servono a migliorare
            l'esperienza d'uso dell'utente e le prestazioni della pagina.
          </p>
          <p class="cn">
            我们使用严格必要且必不可少的
            Cookie，以便用户能够使用我们的网站、自由浏览、访问安全区域、配置个性化选项等。我们还使用收集网站使用分析数据的
            Cookie，用于改善用户体验和页面性能。
          </p>
        </div>
        <div class="bi">
          <p class="it">
            In alcune aree del sito possono essere installati cookie di terze
            parti. Non controlliamo i cookie utilizzati da tali terzi su siti
            web esterni. Per maggiori informazioni sui cookie di siti web di
            terzi, consigliamo di consultare le rispettive politiche sui cookie.
          </p>
          <p class="cn">
            在网站的某些区域可能会安装第三方
            Cookie。我们无法控制这些第三方在外部网站上使用的
            Cookie。有关第三方网站 Cookie 的更多信息，建议查阅其各自的 Cookie
            政策。
          </p>
        </div>
        <div class="bi">
          <p class="it lead">
            I cookie utilizzati da questo sito sono i seguenti:
          </p>
          <p class="cn">本网站使用的 Cookie 如下：</p>
        </div>

        <table class="cookie-table">
          <thead>
            <tr>
              <th>Cookie</th>
              <th>
                <span class="th-it">Origine</span>
                <span class="th-cn">来源</span>
              </th>
              <th>
                <span class="th-it">Finalità</span>
                <span class="th-cn">用途</span>
              </th>
              <th>
                <span class="th-it">Scadenza</span>
                <span class="th-cn">有效期</span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="c-name">1p_jar</td>
              <td>google.com</td>
              <td>
                <span class="it"
                  >Cookie analitico, trasferisce dati a Google.</span
                >
                <span class="cn">分析性 Cookie，向 Google 传输数据。</span>
              </td>
              <td>
                <span class="it">1 mese</span>
                <span class="cn">1 个月</span>
              </td>
            </tr>
            <tr>
              <td class="c-name">ANID, AID</td>
              <td>google.com</td>
              <td>
                <span class="it">Cookie pubblicitario.</span>
                <span class="cn">广告 Cookie。</span>
              </td>
              <td>
                <span class="it">1 anno</span>
                <span class="cn">1 年</span>
              </td>
            </tr>
            <tr>
              <td class="c-name">CONSENT</td>
              <td>—</td>
              <td>
                <span class="it"
                  >Cookie di Google Maps, utilizzato per il funzionamento della
                  mappa di Google nella pagina di contatto.</span
                >
                <span class="cn"
                  >Google 地图 Cookie，用于联系页面上 Google 地图的运行。</span
                >
              </td>
              <td>
                <span class="it">Indefinita</span>
                <span class="cn">无限期</span>
              </td>
            </tr>
            <tr>
              <td class="c-name">NID</td>
              <td>google.com</td>
              <td>
                <span class="it">Cookie pubblicitario.</span>
                <span class="cn">广告 Cookie。</span>
              </td>
              <td>
                <span class="it">6 mesi</span>
                <span class="cn">6 个月</span>
              </td>
            </tr>
            <tr>
              <td class="c-name">IDE</td>
              <td>doubleclick.net</td>
              <td>
                <span class="it"
                  >Utilizzato da Google DoubleClick per registrare e riferire le
                  azioni dell'utente sul sito web dopo la visualizzazione o il
                  clic su un annuncio, con lo scopo di misurare l'efficacia
                  dell'annuncio e mostrare annunci specifici per l'utente.</span
                >
                <span class="cn"
                  >Google DoubleClick
                  使用，用于在用户查看或点击广告后记录并报告其在网站上的行为，以衡量广告效果并向用户展示特定广告。</span
                >
              </td>
              <td>
                <span class="it">1 anno e 7 mesi</span>
                <span class="cn">1 年 7 个月</span>
              </td>
            </tr>
            <tr>
              <td class="c-name">_gads, _sonar</td>
              <td>doubleclick.net</td>
              <td>
                <span class="it">Cookie pubblicitario.</span>
                <span class="cn">广告 Cookie。</span>
              </td>
              <td>
                <span class="it">1 anno</span>
                <span class="cn">1 年</span>
              </td>
            </tr>
            <tr>
              <td class="c-name">_fbp</td>
              <td>doubleclick.net</td>
              <td>
                <span class="it">Cookie pubblicitario.</span>
                <span class="cn">广告 Cookie。</span>
              </td>
              <td>
                <span class="it">3 mesi</span>
                <span class="cn">3 个月</span>
              </td>
            </tr>
            <tr>
              <td class="c-name">cto_lwid</td>
              <td>doubleclick.net</td>
              <td>
                <span class="it">Cookie pubblicitario.</span>
                <span class="cn">广告 Cookie。</span>
              </td>
              <td>
                <span class="it">13 mesi</span>
                <span class="cn">13 个月</span>
              </td>
            </tr>
            <tr>
              <td class="c-name">_ga</td>
              <td>—</td>
              <td>
                <span class="it">Utilizzato per distinguere gli utenti.</span>
                <span class="cn">用于区分用户。</span>
              </td>
              <td>
                <span class="it">2 anni</span>
                <span class="cn">2 年</span>
              </td>
            </tr>
            <tr>
              <td class="c-name">_gid</td>
              <td>—</td>
              <td>
                <span class="it"
                  >Cookie analitico collegato a Google Analytics, utilizzato per
                  distinguere gli utenti.</span
                >
                <span class="cn"
                  >与 Google Analytics 相关的分析性 Cookie，用于区分用户。</span
                >
              </td>
              <td>
                <span class="it">1 giorno</span>
                <span class="cn">1 天</span>
              </td>
            </tr>
            <tr>
              <td class="c-name">_gat</td>
              <td>—</td>
              <td>
                <span class="it"
                  >Utilizzato per differenziare i diversi oggetti di
                  tracciamento creati durante la sessione. Il cookie viene
                  creato al caricamento della libreria JavaScript e non esiste
                  una versione precedente del cookie _gat.</span
                >
                <span class="cn"
                  >用于区分会话期间创建的不同跟踪对象。该 Cookie 在加载
                  JavaScript 库时创建，且不存在 _gat Cookie 的早期版本。</span
                >
              </td>
              <td>
                <span class="it">Sessione</span>
                <span class="cn">会话</span>
              </td>
            </tr>
            <tr>
              <td class="c-name">_cookieconsent</td>
              <td>—</td>
              <td>
                <span class="it"
                  >Memorizza lo stato del consenso ai cookie dell'utente per il
                  dominio.</span
                >
                <span class="cn">存储用户对该域名的 Cookie 同意状态。</span>
              </td>
              <td>
                <span class="it">1 anno</span>
                <span class="cn">1 年</span>
              </td>
            </tr>
            <tr>
              <td class="c-name">_cfduid</td>
              <td>workable</td>
              <td>
                <span class="it">Identifica traffico affidabile.</span>
                <span class="cn">识别可信流量。</span>
              </td>
              <td>
                <span class="it">1 anno</span>
                <span class="cn">1 年</span>
              </td>
            </tr>
          </tbody>
        </table>
      </section>

      <section class="sec">
        <h2 class="sec-title">
          <span class="it">Come gestire i cookie?</span>
          <span class="cn">如何管理 Cookie？</span>
        </h2>
        <div class="bi">
          <p class="it">
            Per utilizzare questo sito web è necessaria l'installazione dei
            cookie. Tenga presente che, se rifiuta o elimina i cookie di
            navigazione, non potremo mantenere le Sue preferenze ed è possibile
            che alcune funzionalità delle pagine web non siano operative.
          </p>
          <p class="cn">
            使用本网站需要安装 Cookie。请注意，如果您拒绝或删除浏览
            Cookie，我们将无法保留您的偏好，且部分网页功能可能无法正常运行。
          </p>
        </div>
        <div class="bi">
          <p class="it">
            Lei può revocare il consenso prestato interrompendo la navigazione,
            non accettando i cookie o configurando il proprio browser per
            bloccarli ed eventualmente eliminarli. Maggiori informazioni sono
            disponibili per ciascun browser:
          </p>
          <p class="cn">
            您可以通过停止浏览、不接受 Cookie 或将浏览器配置为阻止并在必要时删除
            Cookie 来撤销已给予的同意。各浏览器的更多信息如下：
          </p>
        </div>
        <ul class="browser-list">
          <li>
            <span class="it"
              >Internet Explorer 8 e versioni successive: InPrivate</span
            >
            <span class="cn"
              >Internet Explorer 8 及以上版本：InPrivate（隐私浏览）</span
            >
          </li>
          <li>
            <span class="it"
              >Safari 2 e versioni successive: Navigazione privata</span
            >
            <span class="cn">Safari 2 及以上版本：隐私浏览</span>
          </li>
          <li>
            <span class="it"
              >Opera 10.5 e versioni successive: Navigazione privata</span
            >
            <span class="cn">Opera 10.5 及以上版本：隐私浏览</span>
          </li>
          <li>
            <span class="it"
              >Firefox 3.5 e versioni successive: Navigazione privata</span
            >
            <span class="cn">Firefox 3.5 及以上版本：隐私浏览</span>
          </li>
          <li>
            <span class="it"
              >Google Chrome 10 e versioni successive: Incognito</span
            >
            <span class="cn">Google Chrome 10 及以上版本：无痕模式</span>
          </li>
        </ul>
      </section>

      <div id="cookiefirst-policy-page"></div>
      <div id="cookiefirst-cookies-table"></div>

      <div class="foot-note">
        <p class="it">
          La presente politica sui cookie è stata creata e aggiornata da
          CookieFirst.com.
        </p>
        <p class="cn">本 Cookie 政策由 CookieFirst.com 创建并更新。</p>
        <p class="it">
          La presente tabella dei cookie è stata creata e aggiornata dalla
          piattaforma di gestione del consenso CookieFirst.
        </p>
        <p class="cn">本 Cookie 表格由 CookieFirst 同意管理平台创建并更新。</p>
      </div>
    </div>
    <Foot style="width: 100%"></Foot>
  </div>
</template>
<script>
import Head from "../../components/head/HomePageTop.vue";
import Foot from "@/components/foot/Foot.vue";
export default {
  data() {
    return {};
  },
  components: { Head, Foot },
  computed: {
    isZh() {
      return !!this.$store.state.fanyi;
    },
  },
  created() {},
  methods: {},
};
</script>
<style lang="scss" scoped="scoped">
@import "@/css/mixin.scss";

$accent: #009246;

.legal-wrap {
  background: #f4f6f9;
  padding: 0 0 60px;

  &.lang-it .cn,
  &.lang-it .th-cn {
    display: none !important;
  }

  &.lang-cn .it,
  &.lang-cn .th-it {
    display: none !important;
  }
}

.page {
  width: 900px;
  margin: 30px auto 60px;
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 8px 30px rgba(20, 30, 60, 0.07);
  padding: 50px 60px 56px;
}

.doc-header {
  text-align: center;
  padding-bottom: 26px;
  border-bottom: 2px solid #f0f2f5;
  margin-bottom: 34px;

  .doc-title {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;

    // $fanyi 单行标题（与 Condizioni-generali / Informativa-sulla-privacy 一致）
    &.doc-title-single {
      display: block;
      font-size: 30px;
      font-weight: 700;
      color: #1d2129;
      line-height: 1.2;
      text-align: center;
      margin: 0;
    }

    // 标题中意文样式一致（lang-cn 下仅显示 .cn）
    span.it,
    span.cn {
      font-size: 30px;
      font-weight: 700;
      color: #1d2129;
      line-height: 1.2;
    }
  }

  .doc-sub {
    margin-top: 14px;
    font-size: 13px;
    color: #a0a8b5;
    letter-spacing: 0.5px;
  }
}

.sec {
  margin-bottom: 34px;

  .sec-title {
    display: flex;
    flex-direction: column;
    padding-left: 14px;
    border-left: 4px solid $accent;
    margin-bottom: 20px;

    .it {
      font-size: 19px;
      font-weight: 700;
      color: #1d2129;
      line-height: 1.35;
    }

    .cn {
      font-size: 13px;
      color: #86909c;
    }
  }
}

.group-label {
  display: inline-flex;
  flex-direction: column;
  background: #f0faf4;
  border-radius: 8px;
  padding: 6px 14px;
  margin: 8px 0 16px;

  .it {
    font-size: 14px;
    font-weight: 600;
    color: $accent;
  }

  .cn {
    font-size: 12px;
    color: #5a9e72;
  }
}

.type-card {
  background: #f7f8fa;
  border-radius: 10px;
  padding: 16px 20px;
  margin-bottom: 14px;

  .type-name {
    display: flex;
    align-items: baseline;
    gap: 10px;
    margin-bottom: 8px;

    .it {
      font-size: 15px;
      font-weight: 700;
      color: #1d2129;
    }

    .cn {
      font-size: 13px;
      color: #86909c;
    }
  }

  .it {
    font-size: 14px;
    line-height: 1.7;
    color: #2b303a;
    margin-bottom: 5px;
  }

  .cn {
    font-size: 13px;
    line-height: 1.7;
    color: #86909c;
  }
}

.bi {
  margin-bottom: 14px;

  .it {
    font-size: 14.5px;
    line-height: 1.75;
    color: #2b303a;
    margin-bottom: 6px;

    &.lead {
      font-weight: 600;
    }
  }

  .cn {
    font-size: 13.5px;
    line-height: 1.75;
    color: #86909c;
  }
}

.cookie-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 6px;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 0 0 1px #ebeef5;

  th,
  td {
    text-align: left;
    padding: 12px 14px;
    vertical-align: top;
    font-size: 13.5px;
    line-height: 1.6;
  }

  thead th {
    background: #f0faf4;
    color: #1d2129;
    font-weight: 700;
    font-size: 14px;
    border-bottom: 1px solid #c8e6c9;

    .th-it {
      display: block;
    }

    .th-cn {
      display: block;
      font-size: 13px;
      font-weight: 500;
      color: #5a9e72;
    }
  }

  tbody tr {
    border-bottom: 1px solid #f0f2f5;

    &:nth-child(2n) {
      background: #fafbfc;
    }

    &:hover {
      background: #f5faf7;
    }
  }

  .c-name {
    font-weight: 600;
    color: $accent;
    white-space: nowrap;
  }

  td .it {
    display: block;
    color: #2b303a;
  }

  td .cn {
    display: block;
    color: #86909c;
    font-size: 12.5px;
    margin-top: 2px;
  }
}

.browser-list {
  margin: 0;
  padding: 0;

  li {
    position: relative;
    list-style: none;
    padding: 9px 16px 9px 30px;
    border-radius: 8px;
    margin-bottom: 8px;
    background: #f7f8fa;

    &::before {
      content: "";
      position: absolute;
      left: 14px;
      top: 17px;
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background: $accent;
    }

    .it {
      display: block;
      font-size: 14px;
      color: #2b303a;
    }

    .cn {
      display: block;
      font-size: 13px;
      color: #86909c;
      margin-top: 2px;
    }
  }
}

#cookiefirst-policy-page,
#cookiefirst-cookies-table {
  margin: 0 auto 16px;
}

.foot-note {
  margin-top: 24px;
  padding-top: 18px;
  border-top: 1px dashed #e5e6eb;
  text-align: center;

  .it {
    font-size: 13px;
    color: #86909c;
    margin-bottom: 2px;
  }

  .cn {
    font-size: 12.5px;
    color: #a0a8b5;
    margin-bottom: 10px;
  }
}
</style>
